import {
  useUserContext 
} from "@/context/user";
import {
  gql, useQuery 
} from "@apollo/client";
import {
  useEffect, useMemo, useState 
} from "react";

export const GET_CUSTOMER_DETAILS = gql`
    query accountDetailQuery {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        customer {
            firstname
            lastname
            email
            experience
            level {
                pre_level
                next_level
                score
            }
            created_at
            refer_a_friend_id
            refer_send_email_status
            couponCodes {
                title
                code
                amount
                description
                from_date
                to_date
                type
                order_id
            }
        }
    }
`;

export const useGetCustmerDetail = () => {
  const [{
    isSignedIn 
  }] = useUserContext()
  const [isChecked, setChecked] = useState(false)


  const {
    loading, error, data 
  } = useQuery(
    GET_CUSTOMER_DETAILS,
    {
      skip: !isSignedIn,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
    }
  );

  const {
    customer 
  } = data || {}

  const {
    couponCodes, refer_a_friend_id, refer_send_email_status 
  } = customer || {}

  const placeholderText = useMemo(() => {
    if (loading) {
      return "Loading..."
    }

    return `${globalThis.location?.origin ?? ''}/create-account/?raf=${refer_a_friend_id}`
  }, [refer_a_friend_id, loading])

  useEffect(() => {
    if (refer_send_email_status === 1) {
      setChecked(true)
    }
  }, [refer_send_email_status, loading])

  return {
    loading,
    error,
    data,
    couponCodes,
    refer_a_friend_id,
    placeholderText,
    isChecked,
    setChecked
  };
}
